export const filterUndefinedProps = (props: Record<string, unknown>) => {
  const filteredProps: Record<string, unknown> = {};
  Object.keys(props).forEach(key => {
    if (props[key] !== undefined) {
      filteredProps[key] = props[key];
    }
  });
  return filteredProps;
};
